// extracted by css-extract-rspack-plugin
export default {"root":"stkB74","link-overlay":"u3jwLR","linkOverlay":"u3jwLR"};